'use client';

import FranceIcon from '@/assets/icons/france.svg';
import RdaIcon from '@/assets/icons/rwanda.svg';
import UKIcon from '@/assets/icons/uk.svg';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select';
import { ELanguage } from '@/enums';
import { getLocale } from '@/utils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function NavLinks() {
  // const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);
  // const timeoutRef = useRef<number | null>(null);
  // const navs = [['Voters', '/']];

  const { i18n } = useTranslation();
  const lng = getLocale(i18n.language as ELanguage);
  const [language, setLanguage] = useState(lng);

  const handleChangeLanguage = (e: string) => {
    const lng = getLocale(e as ELanguage);
    setLanguage(lng);
    i18n.changeLanguage(e);
  };

  return (
    <div className="flex items-center">
      <Select value={language?.value} onValueChange={handleChangeLanguage}>
        <SelectTrigger
          className="h-12 w-[138px] rounded-xl border-[#dce5f1] bg-white px-3 text-[#263650] shadow-[0_2px_8px_rgba(27,55,97,0.04)] focus:ring-2 focus:ring-[#1f75d6]/20 focus:ring-offset-0 sm:w-[148px]"
          aria-label="Select language"
        >
          <SelectValue placeholder="Select language" />
        </SelectTrigger>
        <SelectContent className="rounded-xl border-[#dce5f1] shadow-xl">
          <SelectItem value="en-US">
            <div className="flex items-center space-x-2">
              <img className="h-6 w-6 rounded-full object-cover" src={UKIcon} alt="UK flag" />
              <p>English</p>
            </div>
          </SelectItem>
          <SelectItem value="fr">
            <div className="flex items-center space-x-2">
              <img
                className="h-6 w-6 rounded-full object-cover"
                src={FranceIcon}
                alt="French flag"
              />
              <p>French</p>
            </div>
          </SelectItem>
          <SelectItem value="rw">
            <div className="flex items-center space-x-2">
              <img className="h-6 w-6 rounded-full object-cover" src={RdaIcon} alt="Rwanda flag" />
              <p>Kinyarwanda</p>
            </div>
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
